import { useEffect, useState } from 'react';

let toastCallback = null;

export function showToast(message, type = 'success') {
  if (toastCallback) {
    toastCallback({ message, type });
  }
}

export function ToastContainer() {
  const [toast, setToast] = useState(null);

  useEffect(() => {
    toastCallback = (data) => {
      setToast(data);
      setTimeout(() => setToast(null), 2500);
    };
    return () => { toastCallback = null; };
  }, []);

  if (!toast) return null;

  const bgColor = toast.type === 'error' 
    ? 'bg-red-600' 
    : toast.type === 'warning' 
      ? 'bg-yellow-600' 
      : toast.type === 'info'
        ? 'bg-gray-600'
        : 'bg-[#0288d1]';

  return (
    <div 
      data-testid="toast-notification"
      className={`fixed bottom-20 left-4 right-4 ${bgColor} text-white px-4 py-3 rounded-lg shadow-lg z-[100] text-sm font-medium text-center animate-slide-up`}
    >
      {toast.message}
    </div>
  );
}
